// extracted by mini-css-extract-plugin
export var bodySections = "_ag-8";
export var gray = "_ag-7";
export var green = "_ag-4";
export var iconContainer = "_ag-9";
export var iconWidgetContainer = "_ag-1";
export var phoneIcon = "_ag-2";
export var red = "_ag-5";
export var statusDot = "_ag-3";
export var widgetContainer = "_ag-0";
export var yellow = "_ag-6";